import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./pagination.css";
const Pagination = ({ onChangepage, rows, limit, page }) => {
  let pages = 0;
  if (limit < rows) {
    pages = Math.round(rows / limit);
    pages = pages <= 0 ? 0 : pages + (rows % limit > 0 ? 1 : 0);
  }

  return (
    <div className="flex container-pagination">
      {page > 1 && (
        <div onClick={() => onChangepage(page - 1)} className="margin-auto">
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
      )}
      <div className="font1 margin-auto"> {page}</div>
      {page < pages && (
        <div onClick={() => onChangepage(page + 1)} className="margin-auto">
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      )}
    </div>
  );
};

export default Pagination;
